<template>
  <g-page-wrapper>
    <g-contents>
        <section class="-wrapper-tile -wrapper-column fitting- -border-radius-1">
          <div class="-header">
            <div class="-wrapper-column">
            <p class="-h2 -font-weight-medium">{{ $t('pages_contract_ContractInfo.trend.month.bill') }}</p>
            </div>
          </div>

          <div class="-tile-container -bg-white -border-radius-1 -overflow-x-hidden -overflow-y-hidden">

            <div class="-wrapper">
              <div style="float: left;width: 98%">
                <div class="dropDown-wrap custom-select">
                  <g-dropdown
                    style="padding: 10px;width: 130px;float:left;"
                    id="dashboard-payment-chart-select-month"
                    text-class="-mx-0 -pr-0 -pl-2"
                    v-model="category"
                    @change="changeCategory">
                    <g-dropdown-item-wrap class="-width-100 -bg-white -box-shadow-level-4">
                      <g-dropdown-item value="all" text="" :text="$t('pages_contract_ContractInfo.column.headerName.all')"></g-dropdown-item>
                      <g-dropdown-item value="serviceIds" text="" :text="$t('pages_contract_ContractInfo.column.headerName.serviceIds')"></g-dropdown-item>
                      <g-dropdown-item value="month" text="" :text="$t('pages_contract_ContractInfo.column.headerName.invoiceMonth')"></g-dropdown-item>
                      <g-dropdown-item value="id" text="" :text="$t('pages_contract_ContractInfo.column.headerName.id')"></g-dropdown-item>
                      <g-dropdown-item value="contractName" text="" :text="$t('pages_contract_ContractInfo.column.headerName.contractName')"></g-dropdown-item>
                    </g-dropdown-item-wrap>
                  </g-dropdown>
                </div>
                <div v-if="category === 'month' && category !== 'all'">
                  <div style="float: left;margin-top: 5px">
                    <date-picker
                      :lang="lang"
                      type="month"
                      @change="onSearch"
                      v-model="startMonth">
                    </date-picker>
                    <date-picker
                      :lang="lang"
                      type="month"
                      @change="onSearch"
                      v-model="endMonth">
                    </date-picker>
                  </div>
                  <div style="float: left">
                    <g-search-bar
                      no-border
                      placeholder="Search anything"
                      @keydown="onSearch"
                      v-model="searchText"
                    />
                  </div>
                </div>
                <g-search-bar
                  v-if="category !== 'month'"
                  id="contract-info-list-grid-searchbar"
                  no-border
                  placeholder="Search anything"
                  @keydown="onSearch"
                  v-model="searchText"
                />
              </div>
              <div style="float: right;width: 2%">
                <g-button
                  id="contract-info-list-grid-excel-download"
                  variant="borderless"
                  size="small"
                  icon-only
                  class="-minus-ml-2 -mt-2 top-right"
                  @click="onClickDownload">
                  <g-icon name="get_app"  width="16px" height="16px" color="gray-1" />
                </g-button>
              </div>
            </div>
            <ag-grid-vue
              id="contract-info-list-grid"
              style="height: 631px;"
              class="ag-theme-balham"
              row-height="30"
              header-height="30"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :gridOptions="gridOptions"
              :rowData="contracts"
              :modules="modules"
              @row-data-changed="onRowDataChanged"
              @cell-clicked="rowClicked"
              @grid-ready="onGridReady">
            </ag-grid-vue>
            <g-pagenation
              id="contract-info-list-grid-paging"
              class="-py-6"
              :page-no="this.paging.pageNo"
              :page-size-list="pageSizeList"
              :page-size="this.paging.size"
              :total-count="this.paging.totalCount"
              @change-page-no="onChangePageNo"
              @change-page-size="onChangePageSize"/>
          </div>

        </section>


    </g-contents>
  </g-page-wrapper>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/ko'
import { AgGridVue } from 'ag-grid-vue';
import AgGridMixin from "@/pages/mixin/AgGrid.mixin";
import {AUTH_GROUP, CURRENCY_SYMBOL, DEFAULT_OPTION_PER_PAGE, DEFAULT_PAGE_SIZE} from "@/constants/constants";
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import LinkCell from "@/pages/components/ag-grid/LinkCell";
import ServiceIdsPopId from "@/pages/contract/components/components/ServiceIdsPopid";

export default {
  name: 'ContractInfoCostByInvoice',
  componentName: 'ContractInfoCostByInvoice',
  components: {
    DatePicker
    ,AgGridVue
  },
  computed: {
    ...mapGetters('contract', ['pagingDTO','contracts', 'contractSearch']),
    ...mapGetters('user', ['userInfo'])
  },
  beforeMount() {
    if(this.contractSearch !== undefined && this.contractSearch.loaded === true) {
      this.category = this.contractSearch.category
      this.searchText = this.contractSearch.searchText
      this.paging.size = this.contractSearch.pageSize
      this.startMonth = this.contractSearch.startMonth
      this.endMonth = this.contractSearch.endMonth
      this.size = this.contractSearch.pageSize
      this.paging.pageNo = this.contractSearch.pageNo
    } else {
      let now = new Date()
      this.startMonth = new Date(now.setMonth(now.getMonth() - 1))
      this.endMonth = now
    }
    this.gridOptions = {
      ...this.gridOptions,
      onGridReady: (params) => {
        this.gridOptions.api.sizeColumnsToFit();
        this.columnDefs.forEach(item => {
          const column = this.gridOptions.columnApi.getColumn(item.field)
          column.addEventListener('sortChanged', () => {
            this.selectCol++
            this.$showSpinner(true)
            const sortVal = column.getSort()

            if('totalTradeAmountByKrw'=== item.field){
              this.orderCol = item.field + ' * 1'
            }else{
              this.orderCol = item.field
            }

            this.size = DEFAULT_PAGE_SIZE

            if (sortVal === 'desc') {
              this.desc = true
            } else if (sortVal === 'asc') {
              this.desc = false
            } else {
              this.orderCol = null
              this.desc = null
            }
            if(this.selectCol === 1) {
              this.getInitConstract()
            }
          })
        })
      }
    }
  },
  mixins: [AgGridMixin()],
  data() {
    return {
      startMonth: '',
      endMonth: '',
      lang: "ko",
      date: null,
      searchText: '',
      category: 'all',
      pageNo: 1,
      size: DEFAULT_PAGE_SIZE,
      pageSizeList: DEFAULT_OPTION_PER_PAGE,
      orderCol: '',
      selectCol: '',
      clickCount: 0,
      desc: true,
      paging: {
        pageNo: 1,
        size : DEFAULT_PAGE_SIZE,
        totalCount : 0
      },
      defaultColDef: {
        suppressMenu: true,
        sortable: true,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        resizable: true
      },
      columnDefs: [
        {
          headerName: this.$t('pages_contract_ContractInfo.column.headerName.no'),
          field: "no",
          width: 80,
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"},
          comparator: () => false
        },
        {
          headerName: this.$t('pages_contract_ContractInfo.column.headerName.customerName'),
          field: "customerName",
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"},
          comparator: () => false
        },
        {
          headerName: this.$t('pages_contract_ContractInfo.column.headerName.serviceIds'),
          field: "serviceIds",
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"},
          comparator: () => false,
          cellRendererFramework: LinkCell({ callback: (params) => {
            this.openPopup(params)
            }})
        },
        {
          headerName: this.$t('pages_contract_ContractInfo.column.headerName.invoiceMonth'),
          field: "invoiceMonth",
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"},
          comparator: () => false
        },
        {
          headerName: this.$t('pages_contract_ContractInfo.column.headerName.id'),
          field: "id",
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"},
          comparator: () => false
        },
        {
          headerName: this.$t('pages_contract_ContractInfo.column.headerName.contractName'),
          field: "contractName",
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"},
          comparator: () => false
        },

        {
          headerName: this.$t('pages_contract_ContractInfo.column.headerName.totalTradeAmountByKrw'),
          field: "totalTradeAmountByKrw",
          unSortIcon: true,
          cellStyle : {"cursor":"pointer",'text-align': "right" },
          comparator: () => false,
          cellRenderer: (params) => {
            return CURRENCY_SYMBOL.KRW + parseInt(params.value).toLocaleString()
          }
        },
        {
          headerName: this.$t('pages_contract_ContractInfo.column.headerName.startDate'),
          field: "startDate",
          unSortIcon: true,
          comparator: () => false,
          cellStyle : {"cursor":"pointer"}
        },
        {
          headerName: this.$t('pages_contract_ContractInfo.column.headerName.endDate'),
          field: "endDate",
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"},
          comparator: () => false
        },
        {
          headerName: 'employeeCode',
          field: "employeeCode",
          hide: true,
          comparator: () => false
        },

        {
          headerName: 'customerCode',
          field: "customerCode",
          hide: true,
          comparator: () => false
        },

        {
          headerName: 'deptCode',
          field: "deptCode",
          hide: true,
          comparator: () => false
        },

        {
          headerName: this.$t('pages_contract_ContractInfo.column.headerName.contractStatusName'),
          field: "contractStatusName",
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"},
          comparator: () => false,
          cellRenderer : parameter => {
            if( parameter.value ===this.$t('pages_contract_ContractInfo.contract.ing') ){
              return '<p class="-tag green-">'+parameter.value+'</p>';
            } else if( parameter.value === this.$t('pages_contract_ContractInfo.contract.end') ) {
              return '<p class="-tag gray-">'+parameter.value+'</p>';
            } else if( parameter.value === this.$t('pages_contract_ContractInfo.contract.needextend')) {
              return '<p class="-tag yellow-">'+parameter.value+'</p>';
            } else if( parameter.value ===this.$t('pages_contract_ContractInfo.contract.exceed')) {
              return '<p class="-tag red-">'+parameter.value+'</p>';
            }

          }
        },
      ],

    }
  },
  methods: {
    ...mapActions('contract', ['getContract', 'getCSVDownLoad', 'setContractSearch']),
    onGridReady(params) {
      this.setGridParams(params)
      this.fitGrid()
      this.getInitConstract()
      this.rowData = this.bills
    },
    openPopup(item) {
      if(item.value !== '') {
        this.$popupManager.open(ServiceIdsPopId, {text: item.value})
      }
    },
    onChangePageNo(pageNo) {
      this.$showSpinner(true)
      this.paging.pageNo = pageNo
      this.getInitConstract()
      this.fitGrid();
    },
    onChangePageSize(pageSize) {
      this.paging.size = pageSize
      this.fitGrid();
      this.getInitConstract()
    },
    onSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.desc = true
        this.paging.pageNo = 1
        this.getInitConstract()
      }, 500);
    },
    onClickDownload() {
      let month = moment(new Date()).add("-1", "M").format("YYYYMM")
      let url = ''
      if (this.userInfo.auth === AUTH_GROUP.BespinMiddleManager) {
        url = `${location.origin}/api/v1/excel-contracts?companyCode=${this.userInfo.companyCode}&jobTitleCode=${this.userInfo.jobTitleCode}&empAuthDept=${this.userInfo.empAuthDept}&empNo=${this.userInfo.empNo}&searchText=${this.searchText}&size=${this.pagingDTO.totalCount}&month=${month}&orderCol=${this.orderCol}&category=${this.category}&startMonth=${moment(this.startMonth).format('YYYY-MM')}&endMonth=${moment(this.endMonth).format('YYYY-MM')}`
      } else if(this.userInfo.auth === AUTH_GROUP.AccountManager){
        url = `${location.origin}/api/v1/customers-excel/${this.userInfo.customerCode}/depts/${this.userInfo.customerDeptCode}/contracts?companyCode=${this.userInfo.companyCode}&empNo=${this.userInfo.empNo}&searchText=${this.searchText}&size=${this.pagingDTO.totalCount}&month=${month}&orderCol=${this.orderCol}&category=${this.category}&startMonth=${moment(this.startMonth).format('YYYY-MM')}&endMonth=${moment(this.endMonth).format('YYYY-MM')}`
      }
      else {
        url = `${location.origin}/api/v1/excel-contracts?companyCode=${this.userInfo.companyCode}&empNo=${this.userInfo.empNo}&searchText=${this.searchText}&size=${this.pagingDTO.totalCount}&month=${month}&orderCol=${this.orderCol}&category=${this.category}&startMonth=${moment(this.startMonth).format('YYYY-MM')}&endMonth=${moment(this.endMonth).format('YYYY-MM')}`
      }
      let payLoad = {
        url : url,
        fileName : "contracts.csv"
      }
      this.getCSVDownLoad(payLoad)
    },
    selectBillDetail(event) {
      this.setInvoiceDetail(event.data)
      this.$router.push(`/sales/info?&companyCode=${this.invoice.companyCode}&customerCode=${this.invoice.customerCode}&receiveStatusName=${this.invoice.receiveStatusName}&invoiceNo=${this.invoice.invoiceNo}&customerName=${this.invoice.customerName}&deptCode=${event.data.deptCode}&currentMonth=${event.data.invoiceMonth.replace('-','')}&userEmail=${this.userInfo.userEmail}`)
    },
    rowClicked(event){
      if(event.column.colId === 'serviceIds') {
        return
      }
      let month = event.data.invoiceMonth.replace("-",'')
      if(this.userInfo.auth === AUTH_GROUP.BespinSales) {
        this.$router.push(`/contract/detail?id=${event.data.id}&companyCode=${this.userInfo.companyCode}&month=${month}&empNo=${event.data.employeeCode}`)
      }else if(this.userInfo.auth === AUTH_GROUP.AccountManager){
        this.$router.push(`/contract/detail?id=${event.data.id}&companyCode=${this.userInfo.companyCode}&month=${month}&customerCode=${event.data.customerCode+event.data.deptCode}`)
      }else{
        this.$router.push(`/contract/detail?id=${event.data.id}&companyCode=${this.userInfo.companyCode}&month=${month}`)
      }

    },
    onRowDataChanged () {
      this.fitGrid()
    },
    changeCategory() {
      this.paging.pageNo = 1
      this.getInitConstract()
    }
    ,
    getInitConstract(){
      let date = new Date()
      let prevMonth = moment(date.getTime()).add("-1", "M").format("YYYYMM");

      let param = {}
      param.companyCode = this.userInfo.companyCode

      if (this.userInfo.auth === AUTH_GROUP.BespinSales)  {
        param.empNo = this.userInfo.empNo;
      }else{
        param.empNo = ''
      }
      param.orderCol = this.orderCol
      param.desc = this.desc

      param.month = prevMonth;
      param.pageNo = this.paging.pageNo
      param.size = this.paging.size
      param.searchText = this.searchText
      param.startMonth = moment(this.startMonth).format('YYYY-MM')
      param.endMonth = moment(this.endMonth).format('YYYY-MM')

      if (this.userInfo.auth === AUTH_GROUP.AccountManager) {
        param.customerCode = this.userInfo.customerCode
        param.deptCode = this.userInfo.customerDeptCode
      }
      if (this.userInfo.auth === AUTH_GROUP.BespinMiddleManager) {

        param.jobTitleCode = this.userInfo.jobTitleCode
        param.empAuthDept = this.userInfo.empAuthDept
      }
      param.orderCol = this.orderCol
      param.desc = this.desc
      param.category = this.category
      let payload = {
        loaded: true
        , pageNo: this.paging.pageNo
        , searchText: this.searchText
        , category: this.category
        , pageSize: this.paging.size
        , startMonth: this.startMonth
        , endMonth: this.endMonth
      }

      this.setContractSearch(payload)
      this.getContract(param)
    }
  },
  watch: {
    pagingDTO() {
      this.paging.pageNo = this.pagingDTO.pageNo
      this.paging.size = this.pagingDTO.size
      this.paging.totalCount = this.pagingDTO.totalCount
      this.fitGrid()
      this.$showSpinner(false)
      this.selectCol = 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/contract/components/ContractInfoCostByInvoice.vue